import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=5abdd9dc"
import script from "../../controllers/route/route-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/route/route-detail.js?vue&type=script&lang=js&external"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=5abdd9dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports